import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalDeficiencyTicketDbTableDefinition extends DbTableDefinition {
  tableName = 'local_deficiencytickets';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
    databag LONGTEXT,
    extcode VARCHAR(45),
    casenumber INTEGER,
    casenumberwithprefix VARCHAR(45),
    alertcount INTEGER,
    exttype VARCHAR(45),
    info VARCHAR(255),
    reasonid BIGINT(20),
    reasonlabel TEXT,
    ownerid BIGINT(20),
    ownerlabel TEXT,
    ownerobjref VARCHAR(45),
    entitycreatedtstamp BIGINT,
    entitycreateduser VARCHAR(50),
    entitycreateddevicetoken BIGINT(20),
    entitycreatedlocaldeviceid BIGINT(20),
    title VARCHAR(255),
    description TEXT,
    creatorid BIGINT(20),
    creatorlabel TEXT,
    assigneeid BIGINT(20),
    assigneelabel TEXT,
    assigneeobjref VARCHAR(45),
    pinid BIGINT(20),
    pinlabel TEXT,
    completiondate BIGINT,
    latestcompletiondate BIGINT,
    status INTEGER,
    external BOOLEAN
  );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    // Table was added in DB Version 2. Add Create Statement for Version 2
    this.updateStatements.set(2, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);

    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'priority',
        type: 'INTEGER',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'receipttstamp',
        type: 'BIGINT',
      });
      // Follow-up ("Folgeeintrag") reference, see DeficiencyTicket.predecessor
      this.alterStatements.push({
        table: this.tableName,
        col: 'predecessorid',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'predecessorsecondaryid',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'predecessorlabel',
        type: 'TEXT',
      });
    } else {
      this.updateStatements.set(3, [
        `ALTER TABLE ${this.tableName} ADD COLUMN priority INTEGER;`,
      ]);

      // "Erledigt am": the backend overwrites receipttstamp with the moment the
      // ticket was finished
      this.updateStatements.set(58, [
        `ALTER TABLE ${this.tableName} ADD COLUMN receipttstamp BIGINT;`,
      ]);

      // Follow-up ("Folgeeintrag") reference, see DeficiencyTicket.predecessor
      this.updateStatements.set(59, [
        `ALTER TABLE ${this.tableName} ADD COLUMN predecessorid BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN predecessorsecondaryid BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN predecessorlabel TEXT;`,
      ]);
    }
  }
}
